import { shallowEqual, useSelector } from 'react-redux';
import Overview from './Overview/Overview';
import Welcome from './Overview/Welcome';
import { Switch, Route } from 'react-router-dom';
import OverviewDashboard from './Overview/OverviewDashboard/OverviewDashboard';
import hasPermission from './Shared/hasPermission';

const AppOverview = () => {
    const permissions = useSelector((state) => state.auth.permissions, shallowEqual);
    const numSelectedPractices = useSelector((state) => state.practice.selectedPracticeTabs.length);
    const canSeeDash = hasPermission('Dashboard', permissions);
    const isWelcomeHidden = canSeeDash || numSelectedPractices > 0;
    return (
        <Switch>
            <Route path="/practices/:practiceId">
                <Overview />
            </Route>
            <Route path='/'>
                {!isWelcomeHidden && <Welcome />}
                {canSeeDash && <OverviewDashboard />}
            </Route>
        </Switch>
    );
};

export default AppOverview;
